import { defineBoot } from '@quasar/app-vite/wrappers';
import CancelButton from 'components/buttons/CancelButton.vue';
import InfoButton from 'components/buttons/InfoButton.vue';
import NegativeButton from 'components/buttons/NegativeButton.vue';
import PrimaryButton from 'components/buttons/PrimaryButton.vue';
import PrimaryInlineButton from 'components/buttons/PrimaryInlineButton.vue';
import CardHeader from 'components/CardHeader.vue';
import KebabMenu from 'components/KebabMenu.vue';
import ResponsiveDrawer from 'components/ResponsiveDrawer.vue';
import TabPanel from 'components/TabPanel.vue';
import TabPanels from 'components/TabPanels.vue';
import ZubieDialog from 'components/ZubieDialog.vue';

/**
 * Registers certain components as globals.
 *
 * @param {{ app: import('vue').App }} payload
 */
export default defineBoot(({ app }) => {
  app.component('CardHeader', CardHeader);
  app.component('CardHeader', CardHeader);
  app.component('KebabMenu', KebabMenu);
  app.component('KebabMenu', KebabMenu);
  app.component('ResponsiveDrawer', ResponsiveDrawer);
  app.component('ResponsiveDrawer', ResponsiveDrawer);
  app.component('TabPanel', TabPanel);
  app.component('TabPanel', TabPanel);
  app.component('TabPanels', TabPanels);
  app.component('TabPanels', TabPanels);
  app.component('CancelButton', CancelButton);
  app.component('InfoButton', InfoButton);
  app.component('NegativeButton', NegativeButton);
  app.component('PrimaryButton', PrimaryButton);
  app.component('PrimaryInlineButton', PrimaryInlineButton);
  app.component('ZubieDialog', ZubieDialog);
});
